/* tslint:disable */
/* eslint-disable */
/**
 * Alobacsi API
 * The Alobacsi API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ClinicInfo } from './ClinicInfo';
import {
    ClinicInfoFromJSON,
    ClinicInfoFromJSONTyped,
    ClinicInfoToJSON,
} from './ClinicInfo';

/**
 * 
 * @export
 * @interface ClinicControllerGetClinics200Response
 */
export interface ClinicControllerGetClinics200Response {
    /**
     * 
     * @type {number}
     * @memberof ClinicControllerGetClinics200Response
     */
    count: number;
    /**
     * 
     * @type {Array<ClinicInfo>}
     * @memberof ClinicControllerGetClinics200Response
     */
    data: Array<ClinicInfo>;
}

/**
 * Check if a given object implements the ClinicControllerGetClinics200Response interface.
 */
export function instanceOfClinicControllerGetClinics200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "count" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function ClinicControllerGetClinics200ResponseFromJSON(json: any): ClinicControllerGetClinics200Response {
    return ClinicControllerGetClinics200ResponseFromJSONTyped(json, false);
}

export function ClinicControllerGetClinics200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClinicControllerGetClinics200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'data': ((json['data'] as Array<any>).map(ClinicInfoFromJSON)),
    };
}

export function ClinicControllerGetClinics200ResponseToJSON(value?: ClinicControllerGetClinics200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'data': ((value.data as Array<any>).map(ClinicInfoToJSON)),
    };
}

